import React from 'react';
import { connect } from 'dva';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Table, Tooltip, Button, Icon, Spin, Modal } from 'antd';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { CopyIcon, PencilIcon, TrashIcon } from '../../Icons';
import { userRoleInCurrentProject } from '../../../selectors/app';
import Roles from '../../../utils/roles';
import {
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_SHOW_NOTIFICATION,
} from '../../../models/app';
import {
  ACTION_PAGEGROUPS_LOADLIST,
  ACTION_PAGEGROUPS_REMOVE,
} from '../../../models/pageGroups';
import { ROUTE_PAGE_GROUPS_NEW } from '../../../routes';
import styles from './../styles.less';

const { Column } = Table;
const createBtnAvailableRoles = [
  Roles.role_super_admin.id,
  Roles.role_admin.id,
  Roles.role_editor.id,
];

class PageGroupsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        search: undefined,
      },
      removedId: null,
    };

    this.projectId = this.props.currentProjectId || this.props.match.params.projectId;
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.PageGroups.Title',
        description: 'Component.PageGroups.Description',
      },
    });

    this.showNotifications();
  }

  getData = (psf) => {
    const projectId = this.projectId;
    const filter = { name: this.state.filter.search };
    const payload = { projectId, filter, ...psf };

    if (Object.keys(this.state.filter).length > 0) {
      payload.filtered = true;
    }

    return this.props.dispatch({ type: ACTION_PAGEGROUPS_LOADLIST, payload });
  };

  showNotifications() {
    this.props.dispatch({ type: ACTION_APP_SHOW_NOTIFICATION });
  }

  goToPageGroupsNew = () => {
    const projectId = this.projectId;
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_PAGE_GROUPS_NEW, projectId },
    });
  };

  removeItemModal = item => () => {
    return Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.PageGroups.Modal.Description' },
        { pageGroupName: item.name },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => {
        this.removeItem(item.id);
      },
    });
  };

  removeItem = (id) => {
    this.props
      .dispatch({ type: ACTION_PAGEGROUPS_REMOVE, payload: { id } })
      .then((response) => {
        if (response.success) {
          this.showNotifications();
          this.setState({ removedId: id });
        }
      });
  };

  render() {
    const { projectId, filter, removedId } = this.state;
    const { loading, userRole } = this.props;
    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.PageGroups.List.SearchByNamePlaceholder',
                })}
              />
              <Col span={14} className="text-right">
                {createBtnAvailableRoles.includes(userRole) && (
                  <Button
                    size="large"
                    type="primary"
                    onClick={this.goToPageGroupsNew}
                  >
                    <Icon type="plus" />
                    <FormattedMessage id="Component.PageGroups.Create" />
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={loading.models.pageGroups}>
          <AjaxTable
            getData={this.getData}
            rowKey="id"
            updateKey={JSON.stringify([filter, projectId, removedId])}
          >
            <Column
              dataIndex="name"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              dataIndex="has_invalid_urls"
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Status',
              })}
              sorter
              width={150}
              render={(data) => {
                return data ? (
                  <div className={styles.warning}>
                    <FormattedMessage id="Grid.Column.Status.Invalid" />
                  </div>
                ) : (
                  <div>
                    <FormattedMessage id="Grid.Column.Status.Valid" />
                  </div>
                );
              }}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Copy',
                    })}
                  >
                    <Link to={`./new/${item.id}`}>
                      <CopyIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={this.removeItemModal(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ app, loading }) => ({
  currentProjectId: app.currentProjectId,
  loading,
  userRole: userRoleInCurrentProject(app),
}))(injectIntl(PageGroupsList));



// WEBPACK FOOTER //
// ./src/components/PageGroups/PageGroupsList/index.js